import { jsx as _jsx } from "react/jsx-runtime";
import svgData from "./svgData";
import { PathElement } from "../../svgHelpers";
const ChatsOutline = (props) => _jsx(PathElement, { ...props, path: svgData.path.d });
export default ChatsOutline;
